import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';

@Injectable({
  providedIn: 'root',
})
export class PortalDocumentApi {
  private http = inject(SiaHttpService);

  controllerId = 'portal-document';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getDocument(doucmentId: string) {
    return this.http.get(`${this.controllerId}/${doucmentId}`, {
      responseType: 'blob',
      params: {},
    });
  }
}
